/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function init() {
  $(document).ready(function () {
    setAccordionHeight()
    accordionButtonPressed()
  })
}

function setAccordionHeight() {
  const $accordionItem = $('[accordion-item]')

  $accordionItem.each(function () {
    const $this = $(this)
    const id = $this.attr('accordion-item')

    updateAccordionHeight($this, id, $this)
  })
}

function accordionButtonPressed() {
  setTimeout(function () {
    const $showAccordionButton = $('[data-toggle-accordion-item]')

    $showAccordionButton.on('click', function () {
      const $this = $(this)
      const id = $this.data('toggle-accordion-item')
      const $target = $('[accordion-item="' + id + '"]')
      $this.toggleClass('open')

      updateAccordionHeight($target, id, $this)
    })
  }, 200)
}

function updateAccordionHeight(target, id, activeChecker) {
  const $targetHeight = $('[data-toggle-target-accordion-item="' + id + '"]').height()
  const $toggleHeight = $('[data-toggle-accordion-item="' + id + '"]').outerHeight()

  if (activeChecker.hasClass('open')) {
    target.css('max-height', `calc(${$toggleHeight}px + ${$targetHeight}px + 32px)`)
  } else {
    target.css('max-height', `${$toggleHeight}px`)
  }
}
